module.exports = __webpack_public_path__ + "static/media/2.artworkWindowOverlapping.d3ffa177.png";